const SITE = "https://riceqrcodes.com";

const upsertMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const applySeo = ({
  title,
  description,
  path = "/",
  index = true,
  jsonLd,
}) => {
  const url = `${SITE}${path}`;
  document.title = title;
  upsertMeta("name", "description", description);
  upsertMeta("name", "robots", index ? "index, follow" : "noindex, nofollow");
  upsertMeta("property", "og:title", title);
  upsertMeta("property", "og:description", description);
  upsertMeta("property", "og:url", url);
  upsertMeta("property", "og:type", "website");
  upsertMeta("property", "og:image", `${SITE}/logo512.png`);
  upsertMeta("name", "twitter:card", "summary");
  upsertMeta("name", "twitter:title", title);
  upsertMeta("name", "twitter:description", description);
  upsertMeta("name", "twitter:image", `${SITE}/logo512.png`);

  let canonical = document.head.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute("href", url);

  const existing = document.getElementById("page-jsonld");
  if (!jsonLd) {
    existing?.remove();
    return;
  }
  const script = existing || document.createElement("script");
  script.id = "page-jsonld";
  script.type = "application/ld+json";
  script.textContent = JSON.stringify(jsonLd);
  if (!existing) document.head.appendChild(script);
};

export const HOME_TITLE =
  "Rice QR Codes for Gunny Bags | FCI, PUNSUP & Mandi Tags";
export const HOME_DESCRIPTION =
  "Generate and print unique QR tags for government rice gunny bags. Built for Indian rice millers, FCI, PUNSUP, MARKFED, PUNGRAIN, HAFED and mandi agencies.";

export const LOGIN_TITLE = "Login | RiceQRCodes — Rice Miller QR Tag Software";
export const LOGIN_DESCRIPTION =
  "Sign in to RiceQRCodes to design and print unique QR tags for paddy and rice gunny bags. Agency-ready for FCI, PUNSUP, MARKFED and mandi scanning.";
